import _ from '@/common/helpers';

export default function ({
    target,
    source,
    disableBind = false,
    entityCallback,
}) {
    const context = {
        cache: {},
        isTargetModified: false,
        addition: ((length) => {
            const charset = '23456789abcdefghjkmnpqrstuvwxyz';
            let result = '';
            for (let i = 0; i < length; i += 1) {
                result += charset[Math.floor(Math.random() * charset.length)];
            }
            return result;
        })(5),
    };

    function setTargetValue(self, value) {
        const [model, field] = target.split('.');
        self[model][field] = value;
    }

    function getTargetValue(self) {
        const [model, field] = target.split('.');
        return self[model][field];
    }

    return {
        watch: {
            [source](newValue) {
                if (context.isTargetModified || this.isFormUpdating) {
                    return;
                }
                const id = (newValue || '')
                    .replace(/[^A-Za-z0-9-]/g, ' ')
                    .replace(/\s+/g, '-')
                    .replace(/-{2,}/g, '-')
                    .replace(/^-/g, '')
                    .replace(/-$/g, '')
                    .substring(0, 40)
                    .toLowerCase();
                if (id.length < 1 || /^[-]+$/g.test(id)) {
                    setTargetValue(this, '');
                    return;
                }
                setTargetValue(this, id);
            },
            [target](newValue) {
                if (!newValue) {
                    context.isTargetModified = false;
                }
            },
        },
        methods: {
            async assignSlugAddition() {
                if (this.isFormUpdating) {
                    return;
                }
                const targetInput = this.$el.querySelector('.slug-target input');
                if (context.isTargetModified || !targetInput || _.isBlank(targetInput.value)) {
                    return;
                }
                const {value} = targetInput;

                if (!Reflect.has(context.cache, value)) {
                    try {
                        context.cache[value] = await entityCallback.call(this, value);
                    } catch (error) {
                        if (!('status' in error) || error.status !== 404) {
                            throw error;
                        }
                        context.cache[value] = undefined;
                    }
                }
                if (context.cache[value] !== undefined && !context.isTargetModified) {
                    const newValue = `${value}-${context.addition}`.replace(/-{2,}/g, '-');
                    setTargetValue(this, newValue);
                    context.cache[newValue] = undefined;
                }
            },
            mountSlugHandlers() {
                if (this.isSlugHandlersMounted || disableBind) {
                    return;
                }
                const sourceInput = this.$el.querySelector('.slug-source input');
                const targetInput = this.$el.querySelector('.slug-target input');
                if (!sourceInput || !targetInput) {
                    return;
                }

                sourceInput.addEventListener('blur', () => {
                    if (_.isBlank(sourceInput.value)) {
                        return;
                    }
                    this.assignSlugAddition();
                });

                targetInput.addEventListener('input', () => {
                    context.isTargetModified = !!getTargetValue(this);
                });

                this.isSlugHandlersMounted = true;
            },
        },
        data() {
            return {
                isSlugHandlersMounted: false,
            };
        },
        updated() {
            this.mountSlugHandlers();
        },
    };
}
